import { SiteIdOverrideConfig } from "stores/wizard/config";

export const siteId4: SiteIdOverrideConfig = {
  global: {
    packageWith3PP: true,
    heroImageSrc: "https://forever.travel-assets.com/flex/flexmanager/images/2020/06/25/CA_banff_ex.jpg",
  },
  thirdPartyPackage: {
    duration: {
      queryParam: "duration",
    },
  },
  package: {
    heading: {
      visibleLobSubtitle: false,
    },
  },
  cruise: {
    heading: {
      visibleLobSubtitle: true,
      locSubtitleVariant: "1-888-444-1695",
    },
  },
};
